import { render, staticRenderFns } from "./TenancyCoTenants.vue?vue&type=template&id=48ed42e5&scoped=true&"
import script from "./TenancyCoTenants.vue?vue&type=script&lang=js&"
export * from "./TenancyCoTenants.vue?vue&type=script&lang=js&"
import style0 from "./TenancyCoTenants.vue?vue&type=style&index=0&id=48ed42e5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ed42e5",
  null
  
)

export default component.exports